import axios, { AxiosResponse } from "axios";
import { ArrayFromEnvelope, configService, ObjectFromEnvelope } from "./config.service";
import { Department, DepartmentEmployee, IDepartmentPost } from "../models/department";

class DepartmentService {
  /*******************************
   *          DEPARTMENT
   *******************************/

  async createDepartments(department: IDepartmentPost): Promise<Department> {
    return new Promise((resolve, reject) => {
      axios
        .post<Department>(configService.APIInstitutionUrl("departments.json"), department)
        .then((response: AxiosResponse) => {
          resolve(Department.fromJSON(ObjectFromEnvelope<Department>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }

  async deleteDepartments(departmentId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .delete<Department>(
          configService.APIInstitutionUrl("departments/" + departmentId + ".json")
        )
        .then((response: AxiosResponse) => {
          resolve();
        })
        .catch((error) => reject(error));
    });
  }

  async updateDepartments(department: Department): Promise<Department> {
    return new Promise((resolve, reject) => {
      axios
        .put<Department>(
          configService.APIInstitutionUrl("departments/" + department.id + ".json"),
          department.convertToPutObject()
        )
        .then((response: AxiosResponse) => {
          resolve(Department.fromJSON(ObjectFromEnvelope<Department>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }

  async fetchDepartments(): Promise<Department[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<Department[]>(configService.APIInstitutionUrl("departments.json"), {
          params: {
            institution_id: configService.institutionId()
          }
        })
        .then((response: AxiosResponse) => {
          resolve(Department.fromJSONArray(ArrayFromEnvelope<Department>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /*******************************
   *     DEPARTMENT EMPLOYEES
   *******************************/

  async fetchDepartmentEmployees(): Promise<DepartmentEmployee[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<DepartmentEmployee[]>(configService.APIInstitutionUrl("department_employees.json"), {
          params: {
            institution_id: configService.institutionId()
          }
        })
        .then((response: AxiosResponse) => {
          resolve(
            DepartmentEmployee.fromJSONArray(ArrayFromEnvelope<DepartmentEmployee>(response.data))
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async createDepartmentEmployee(
    departmentId: number,
    departmentEmployeeId: number
  ): Promise<DepartmentEmployee> {
    return new Promise((resolve, reject) => {
      const de: DepartmentEmployee = new DepartmentEmployee();
      de.department_id = departmentId;
      de.employee_id = departmentEmployeeId;
      axios
        .post<DepartmentEmployee>(configService.APIInstitutionUrl("department_employees.json"), de)
        .then((response: AxiosResponse) => {
          resolve(
            DepartmentEmployee.fromJSON(ObjectFromEnvelope<DepartmentEmployee>(response.data))
          );
        })
        .catch((error) => reject(error));
    });
  }

  async deleteDepartmentEmployee(departmentEmployeeId: number): Promise<DepartmentEmployee> {
    return new Promise((resolve, reject) => {
      axios
        .delete<DepartmentEmployee>(
          configService.APIInstitutionUrl("department_employees/" + departmentEmployeeId + ".json")
        )
        .then((response: AxiosResponse) => {
          resolve(response.data as any);
        })
        .catch((error) => reject(error));
    });
  }
}

export const departmentService: DepartmentService = new DepartmentService();
